import styled from "styled-components";
import { useTranslation } from "../../lib/use-translation";
import { HOOPER_LIGHT_BLUE } from "../../shared/constants";

// BottomBar's only call site is VerifyView, a fixed dark full-bleed page
// (see views/verify.tsx) that doesn't follow the light/dark scheme — so
// these colours intentionally stay literal rather than becoming
// text.secondary/primary.main, which would go near-black in the light
// scheme and be invisible on that page's always-dark background.
const FooterContainer = styled.footer`
  text-align: center;
  display: flex;
  font-size: 14px;
  padding-bottom: 10px;
  flex-direction: column;
  align-items: center;
  color: #78808d;
  gap: 16px;
  font-weight: 600;
  flex-direction: column-reverse;
  @media (min-width: 640px) {
    flex-direction: row;
    flex-direction: row-normal;
    justify-content: center;
  }
`;
const FooterContainerDiv = styled.div`
  display: flex;
  gap: 16px;
`;
const FooterContainerA = styled.a`
  color: ${HOOPER_LIGHT_BLUE};
  text-decoration: none;
`;

export default function BottomBar() {
  const { t } = useTranslation("components/ui", "ui");

  const year = new Date().getFullYear();
  return (
    <FooterContainer>
      <div>
        {t("bottomBar.copyright", "© {{year}} Hooper. All rights reserved.").replace(
          "{{year}}",
          String(year),
        )}
      </div>
      <FooterContainerDiv>
        <FooterContainerA href="https://hooper.gg/faq">
          {t("bottomBar.faqs", "FAQs")}
        </FooterContainerA>
        <FooterContainerA
          href="https://hooper.statuspage.io/"
          rel="noreferrer"
          target="_blank"
        >
          {t("bottomBar.status", "Status")}
        </FooterContainerA>
      </FooterContainerDiv>
    </FooterContainer>
  );
}
